module.exports = __webpack_public_path__ + "img/mariage-3-lazy.cb6ae920.jpg";